module.exports = __webpack_public_path__ + "img/011.6f817ec6.png";